import axiosInstance from '../axios/instance'
import { getToken } from './get-token'

export const getQueueItemsUnderReview = async () => {
    try {
        const token = getToken()
        axiosInstance.defaults.headers.common['authorization'] = token
        const response = await axiosInstance.get(process.env.REACT_APP_HUB_URL + '/api/inventory-campaigns/review')
        return response?.data
    } catch (error) {
        console.log(error)
    }
}
